export default defineNuxtPlugin(() => {
  if (typeof document !== 'undefined') {
    // 禁止图片右键菜单 (防止 "图片另存为")
    document.addEventListener('contextmenu', (e) => {
      const target = e.target as HTMLElement;
      // 检查当前元素是 IMG，或者是在 shadow DOM 等情况下的目标
      if (target && target.tagName === 'IMG') {
        e.preventDefault();
      }
    }, true); // 使用捕获阶段，确保优先处理

    // 禁止图片拖拽 (防止拖拽到桌面下载)
    document.addEventListener('dragstart', (e) => {
      const target = e.target as HTMLElement;
      if (target && target.tagName === 'IMG') {
        e.preventDefault();
      }
    }, true);
  }
});
